var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn-toggle',{staticClass:"flex-wrap mb-2",attrs:{"tile":"","color":"deep-purple accent-3"},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},_vm._l((_vm.buttonValues),function(item){return _c('v-btn',{attrs:{"value":item.value,"small":""}},[_vm._v(" "+_vm._s(item.text)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }